import { PHONE_NUMBER } from '@/constants/Common'
import { LocalePerformance } from '../en/performance'

const performance: LocalePerformance = {
  myPerformance: 'Hiệu Suất Của Tôi',
  wins: 'Thắng',
  losses: 'Thua',
  avgPoints: 'Điểm Trung Bình',
  avgPts: 'Điểm TB',
  avgPartner: 'Đối Tác Trung Bình',
  avgPtr: 'Đối Tác TB',
  avgOpponent: 'Đối Thủ Trung Bình',
  win: 'Thắng',
  loss: 'Thua',
  reject: 'Từ Chối',
  validate: 'Xác Nhận',
  validateMatch: 'Xác Nhận Trận Đấu',
  confirmValidateMatch:
    'Bạn có chắc chắn muốn xác nhận điểm số này không? Nếu vậy, trận đấu sẽ được hoàn tất và xếp hạng cầu thủ sẽ được cập nhật.',
  matchSourceLeague: `Nếu điểm số này không chính xác, vui lòng liên hệ với giám đốc sự kiện hoặc nhắn tin ${PHONE_NUMBER} với điểm số chính xác.`,
  deleteMatchConfirm:
    'Nếu bạn xóa trận đấu này, bạn sẽ phải bắt đầu lại từ đầu để nhập điểm số và ảnh hưởng đến xếp hạng của mình',
  halfLife: 'Half-Life',
  avgOpp: 'Avg Opp',
  matchesEmpty: 'Bạn chưa chơi trận nào!',
  matchesEmptyDes: 'Hãy tìm một số người chơi để bắt đầu hành trình của bạn!',
}

export default performance
